module.exports = __webpack_public_path__ + "static/media/ellipsis.2a53b37d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ellipsis.svg
// module id = 539
// module chunks = 0